import React, { useState, useEffect } from "react";
import { Container, Card, Button } from "react-bootstrap";
import { getFirestore, collection, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { app } from '../firebase';
import {Link} from "react-router-dom";

const db = getFirestore(app);

const ViewMessages = ({isDarkMode}) => {
    const [messages, setMessages] = useState([]);

    // Function to fetch messages from the database
    const fetchMessages = () => {
        const messagesRef = collection(db, 'contacts');
        const unsubscribe = onSnapshot(messagesRef, (snapshot) => {
            const messagesArray = [];
            snapshot.forEach((doc) => {
                messagesArray.push({ id: doc.id, ...doc.data() });
            });
            setMessages(messagesArray);
        });
        return unsubscribe;
    };

    useEffect(() => {
        const unsubscribe = fetchMessages();
        return () => unsubscribe(); // Cleanup function to unsubscribe from snapshot updates
    }, []);

    const handleShowReplyForm = (messageId) => {
        const messageToUpdate = messages.find((message) => message.id === messageId);
        if (!messageToUpdate) return;

        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(messageToUpdate.email)}&su=Your%20Reply%20Subject&body=Your%20Reply%20Body`;
        window.open(gmailLink, '_blank');

        const updatedMessages = messages.map((message) =>
            message.id === messageId ? { ...message, replied: true } : message
        );
        setMessages(updatedMessages);

        const messageRef = doc(db, 'contacts', messageId);
        updateDoc(messageRef, { replied: true })
            .then(() => console.log('Message marked as replied'))
            .catch((error) => console.error('Error marking message as replied:', error));
    };

    return (
        <Container style={{ overflowY: "auto", maxHeight: "70vh" }}>
            {messages.map((message) => (
                <Card key={message.id} className="mb-3">
                    <Card.Body>
                        <Card.Title><strong>Username:</strong> {message.username}</Card.Title>
                        <Card.Text><strong>Email:</strong> {message.email}</Card.Text>
                        <Card.Text><strong>Message:</strong> {message.message}</Card.Text>

                        {!message.replied && (
                            <Button variant="primary" style={{ backgroundColor: "orange", width: "20%" }} onClick={() => handleShowReplyForm(message.id)}>
                                Reply
                            </Button>
                        )}

                        {message.replied && (
                            <span style={{ marginLeft: "10px", color: "green" }}>✔</span>
                        )}
                    </Card.Body>
                </Card>
            ))}
            <p>
                <Link to="/" className="btn btn" style={{ backgroundColor: isDarkMode ? '#f8f9fa' : '#333',color: isDarkMode ? '#333' : '#f8f9fa' }}>Back to Home</Link>
            </p>
        </Container>
    );
};

export default ViewMessages;
